import { render } from "./ModalOrderTimeExceeded.vue?vue&type=template&id=12cdeea8"
import script from "./ModalOrderTimeExceeded.vue?vue&type=script&lang=js"
export * from "./ModalOrderTimeExceeded.vue?vue&type=script&lang=js"

import exportComponent from "/media/dev/Develop/Projects/Sjef/kiosk.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__